import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const stored = typeof window !== "undefined" ? localStorage.getItem("sc_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function setToken(token) {
  if (token) {
    localStorage.setItem("sc_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("sc_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function getToken() {
  return localStorage.getItem("sc_token");
}

export function wsUrl(params) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const qs = new URLSearchParams(params).toString();
  return `${base}/api/ws?${qs}`;
}

export function mediaUrl(fileUrl) {
  if (!fileUrl) return "";
  return fileUrl.startsWith("http") ? fileUrl : `${BACKEND_URL}${fileUrl}`;
}

export async function uploadFile(file, scope = "chat") {
  const form = new FormData();
  form.append("file", file);
  form.append("scope", scope);
  const { data } = await axios.post(`${API}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
